<template>
  <div>
    <div class="mw-announcement-active container max-w-4xl">
      <div class="container">
        <p class="mb-0 font-bold text-md">FRESH OFF THE PRESS</p>
        <div class="flex">
          <div class="mw-announcement-content-container">
            <div class="mw-announcement-content">
              <h2>{{ active.title }}</h2>
              <div>
                <div
                  class="html-content"
                  v-html="active.content"
                  style="-webkit-box-orient: vertical;"
                ></div>
                <a
                  v-if="active.url && active.url.length"
                  :href="active.url"
                  class="button mt-4"
                >
                  {{
                    active.label && active.label.length
                      ? active.label
                      : "LEARN MORE"
                  }}
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="home-speaker-controls">
          <button
            type="button"
            class="slick-prev slick-arrow fmi-icon fmi-icon-arrow-left"
            :aria-disabled="activeIndex === 0"
            @click="prevActive()"
            style=""
          ></button
          ><button
            type="button"
            class="slick-next slick-arrow fmi-icon fmi-icon-arrow-right"
            :aria-disabled="activeIndex === initialData.length - 1"
            @click="nextActive()"
            style=""
          ></button>
        </div>
      </div>
      <div class="mw-announcement-image-container">
        <div
          class="mw-announcement-image"
          :style="bkgStyle(active.image)"
        ></div>
        <div class="pagination-circle-container">
          <a
            @click.prevent="updateActive(item, $event)"
            class="pagination-circle"
            v-for="(item, index) in initialData"
            :key="index"
            :class="{ active: index === activeIndex }"
          ></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initialData: { type: Array },
  },
  data() {
    return {
      active: this.initialData[0],
      activeIndex: 0,
    };
  },
  computed: {},
  mounted() {},
  updated() {},
  methods: {
    nextActive() {
      let nextIndex =
        this.activeIndex === this.initialData.length - 1
          ? 0
          : this.activeIndex + 1;
      this.activeIndex = nextIndex;
      this.active = this.initialData[nextIndex];
      const activeButton = document.querySelector("a.pagination-circle.active");
      if (activeButton) activeButton.classList.remove("active");
      const nextButton = document.querySelector(
        `a.pagination-circle[data-index="${nextIndex}"]`
      );
      if (nextButton) nextButton.classList.add("active");
    },
    prevActive() {
      let nextIndex =
        this.activeIndex === 0
          ? this.initialData.length - 1
          : this.activeIndex - 1;
      this.activeIndex = nextIndex;
      this.active = this.initialData[nextIndex];
      const activeButton = document.querySelector("a.pagination-circle.active");
      if (activeButton) activeButton.classList.remove("active");
      const nextButton = document.querySelector(
        `a.pagination-circle[data-index="${nextIndex}"]`
      );
      if (nextButton) nextButton.classList.add("active");
    },
    bkgStyle(image) {
      const toReturn = {
        backgroundImage: 'url("' + image + '")',
      };
      return toReturn;
    },
    updateActive(item, e) {
      if (e && e.target) {
        // Find the active button within the same container
        const container = e.target.closest(".pagination-circle-container");
        if (container) {
          const activeButton = container.querySelector(
            "a.pagination-circle.active"
          );
          if (activeButton) activeButton.classList.remove("active");
        }

        e.target.classList.add("active");
      }
      this.active = item;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/js/vue-components/news-list/news-list.vue